const UserType = {
  LEARNER: 'App\\Models\\LearnerProfile',
  COMPANY: 'App\\Models\\CompanyProfile'
};

export default UserType;
